import { Offer } from '../offers/offer.model';
import { Booking } from './booking.model';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../store/store.model';
import { catchError, map, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { OffersType } from '@toevla-webapplications/core';

@Injectable({
	providedIn: 'root',
})
export class BookingService {
	private _currentBooking: Partial<Booking> = {};

	private readonly http = inject(HttpClient);
	private readonly store = inject(Store<IvvaStore>);

	checkBookingRedirect(id: string, isGroup: boolean): Observable<string | null> {
		const typeUrl = isGroup ? 'checkOfferRedirectGroup' : 'checkOfferRedirect';

		return this.http.get<any>(`/rest/booking/${typeUrl}/${id}`).pipe(
			map((res) => res.bookingUrl),
			catchError(() => of(null))
		);
	}

	getCurrentBooking(): Partial<Booking> {
		return {
			...this._currentBooking,
		};
	}

	new(offer: Offer, isGroup: boolean = false) {
		this.store
			.select('offers', 'user')
			.pipe(take(1))
			.subscribe((user) => {
				if (user) {
					const data: Partial<Booking> = {
						product: offer.id,
						type: offer.type,
						bookingAccount: {
							firstName: user.firstName,
							lastName: user.lastName,
						},
						isGroup,
					};

					if (offer.type === OffersType.ORGANIZED_HOLIDAY) {
						data.camps = [];
					}

					this._currentBooking = data;
				}
			});
	}

	update(data: any) {
		this._currentBooking = {
			...this._currentBooking,
			...data,
		};
	}

	submit(): Observable<any> {
		const b = this.getCurrentBooking();

		if (b.booker && b.bookingAccount) {
			if (!b.booker.firstName) {
				b.booker.firstName = b.bookingAccount.firstName;
			}

			if (!b.booker.lastName) {
				b.booker.lastName = b.bookingAccount.lastName;
			}
		}

		if (b.arrivalDate) {
			b.arrivalDate = this.convertDateStringToIso(b.arrivalDate);
		}

		if (b.departureDate) {
			b.departureDate = this.convertDateStringToIso(b.departureDate);
		}

		if (b.booker?.birthDate) {
			b.booker.birthDate = this.convertDateStringToIso(b.booker.birthDate);
		}

		if (b.camps?.length) {
			b.camps = b.camps
				.filter((c) => c.camp)
				.map((c) => {
					return {
						...c,
						startDate: this.convertDateStringToIso(c.startDate),
						endDate: this.convertDateStringToIso(c.endDate),
					};
				});
		}

		if (b.family?.length) {
			b.family = b.family.map((f) => {
				return {
					...f,
					birthDate: this.convertDateStringToIso(f.birthDate),
				};
			});
		}

		// NOTE: Send both for API
		b.group = b.isGroup;

		return this.http.post(`/rest/booking/${b.product}`, b);
	}

	private convertDateStringToIso(date: string): string {
		const regex = /([0-9]{2})\/([0-9]{2})\/([0-9]{4})/;
		const result = regex.exec(date);

		if (result) {
			const d = new Date(+result[3], +result[2] - 1, +result[1], 12);
			return d.toISOString();
		}

		return date;
	}
}
